import AsignacionParadas from './AsignacionParadas.vue';
import FormularioVariacion from './FormularioVariacion.vue';
import FormularioVariacionFamiliar from './FormularioVariacionFamiliar.vue';
import RegistrosDiariosView from './RegistrosDiariosView.vue';
import InscripcionForm from './InscripcionForm';
import EventualForm from './EventualForm';

export default {
  install: (app, _options) => {
    app.component('TransporteAsignacionParadas', AsignacionParadas);
    app.component('TransporteFormularioVariacion', FormularioVariacion);
    app.component('TransporteFormularioVariacionFamiliar', FormularioVariacionFamiliar);
    app.component('TransporteRegistrosDiariosView', RegistrosDiariosView);
    app.component('TransporteEventualForm', EventualForm);
    app.component('TransporteInscripcionForm', InscripcionForm);
  },
};
